import { Navigate, createFileRoute } from '@tanstack/react-router';

function HomeRedirect() {
  return <Navigate to="/dashboard" search={{ period: 'today' }} replace />;
}

export const Route = createFileRoute('/_authed/')({
  component: HomeRedirect,
});
